import { render, staticRenderFns } from "./Herbs.vue?vue&type=template&id=3ddc63d0&scoped=true&"
import script from "./Herbs.vue?vue&type=script&lang=js&"
export * from "./Herbs.vue?vue&type=script&lang=js&"
import style0 from "./Herbs.vue?vue&type=style&index=0&id=3ddc63d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc63d0",
  null
  
)

export default component.exports